import React, { useState } from "react";
import { FieldArray, Formik, Field, Form, useFormikContext } from "formik";
import {
  faCheck,
  faChevronDown,
  faChevronUp,
  faEdit,
  faTimes,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons";
import { faToggleOn } from "@fortawesome/pro-solid-svg-icons";
import { faToggleOff } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AceEditor from "react-ace";
import { FieldInput, FieldDropSide, AddToolTip } from "../../components";
import RuleFilter from "./RuleFilter";
import { get, isNull } from "lodash";
import { passthroughValidationJsonToString } from "../../utils";
export const AddNewRuleCard = ({
  profileId,
  shrink,
  setShrink,
  isSubRuleSaved,
  setIsSubRuleSaved,
  setRemoveOperator,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const [count, setCount] = useState([]);
  const [editorConsoleCode, setEditorConsoleCode] = useState("");
  const [toggle, setToggle] = useState(true);

  const onSaveRules = (index) => {
    setIsSubRuleSaved(true);
    var isNullPresent = values.ruleSet[index].ruleOperations.some(
      (obj) =>
        obj.firstFieldRule === null ||
        obj?.secondFieldRule0 === null ||
        obj?.secondFieldRule1 === null
    );
    if (
      isNullPresent ||
      isNull(values.ruleSet[index].ruleErrorMessage) ||
      values.ruleSet[index].ruleErrorMessage == "" ||
      values.ruleSet[index].ruleErrorMessage.length > 250
    ) {
      setFieldValue(`ruleSet[${index}].isErrorValidation`, true);
    } else {
      setFieldValue(`ruleSet[${index}].isErrorValidation`, false);
      setFieldValue(
        `ruleSet[${index}].ruleExpression`,
        passthroughValidationJsonToString(
          values.ruleSet[index].ruleOperations,
          values.ruleSet[index]?.filterCondition
        )
      );
      setShrink(null);
    }
  };
  return (
    <>
      <div className="fw-400 ft-18 d-flex w-100">
        {`${values["ruleSet"].length} record(s)`}
      </div>
      <div className="new-rule-layout">
        <FieldArray name="ruleSet">
          {({ insert, remove, push }) => (
            <>
              {values["ruleSet"]?.map((e, index) => {
                return (
                  <>
                    {shrink === index ? (
                      <div className="new-rule-card">
                        <div className="rule-card-header">
                          <div className="rule-drop-down">
                            <FontAwesomeIcon
                              onClick={() => {
                                setShrink(null);
                                setIsSubRuleSaved(false);
                              }}
                              icon={faChevronUp}
                            />
                          </div>
                          <div
                            className="validation-name-flair"
                            style={{ width: "20%" }}
                          >
                            <Field
                              name={`ruleSet[${index}].ruleName`}
                              label={"Rule name"}
                              type="text"
                              value={get(
                                values,
                                `ruleSet[${index}].ruleName`,
                                null
                              )}
                              component={FieldInput}
                            />
                          </div>
                          <div
                            className="expression-function"
                            style={{ width: "60%" }}
                          >
                            <div className="expression-flair">Expression</div>
                            <div className="function-flair">
                              {editorConsoleCode ? editorConsoleCode : "-"}
                            </div>
                          </div>
                          <div
                            style={{
                              width: "13%",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ width: "50%" }} className="">
                              <FontAwesomeIcon
                                onClick={() => {
                                  onSaveRules(index);
                                }}
                                className="rule-tick-icon"
                                icon={faCheck}
                              />
                            </div>
                            <div style={{ width: "50%" }}>
                              <FontAwesomeIcon
                                className="rule-remove-icon"
                                onClick={() => remove(index)}
                                icon={faTimes}
                              />
                            </div>
                          </div>
                        </div>
                        <hr
                          style={{
                            width: "100%",
                            backgroundColor: "black",
                            opacity: "0.3",
                            margin: "0rem 0rem",
                          }}
                        ></hr>
                        <div className="rule-card-footer">
                          {/* <div className="rule-console-toggle">
                            {toggle ? (
                              <div className="toggle-on">
                                <FontAwesomeIcon
                                  onClick={() => {
                                    setToggle(false);
                                  }}
                                  icon={faToggleOff}
                                />
                              </div>
                            ) : (
                              <div className="toggle-off">
                                <FontAwesomeIcon
                                  onClick={() => {
                                    setToggle(true);
                                  }}
                                  icon={faToggleOn}
                                />
                              </div>
                            )}
                            <div
                              style={{
                                marginLeft: "1rem",
                                alignSelf: "center",
                              }}
                            >
                              Editor Console
                            </div>
                          </div> */}
                          {toggle ? (
                            <div className="rules-filter-if">
                              <div className="if-else-functions">
                                <RuleFilter
                                  index={index}
                                  isSubRuleSaved={isSubRuleSaved}
                                />
                              </div>
                              <div className="error-message-card-layout">
                                <div className="error-message-card">
                                  <div className="select-language-field">
                                    <div className="error-message-flair">
                                      Error Message
                                    </div>
                                    <Field
                                      name={`ruleSet[${index}].ruleErrorLanguage`}
                                      placeholder="Select language"
                                      options={[{ Language: "English" }]}
                                      value={
                                        values.ruleSet[index].ruleErrorLanguage
                                      }
                                      disabled
                                      component={FieldDropSide}
                                    />
                                  </div>
                                  <div className="error-message-field d-flex flex-col">
                                    <Field
                                      isRequired
                                      name={`ruleSet[${index}].ruleErrorMessage`}
                                      placeholder="Enter error message"
                                      type="text"
                                      value={
                                        values.ruleSet[index].ruleErrorMessage
                                      }
                                      component={FieldInput}
                                      noLabelTransform
                                    />
                                    {isSubRuleSaved &&
                                    (values.ruleSet[index].ruleErrorMessage ==
                                      "" ||
                                      isNull(
                                        values.ruleSet[index].ruleErrorMessage
                                      )) ? (
                                      <span className="passthrough-error-message">
                                        Required
                                      </span>
                                    ) : isSubRuleSaved &&
                                      values.ruleSet[index].ruleErrorMessage
                                        .length > 250 ? (
                                      <span className="passthrough-error-message">
                                        Error Message should be less than 250
                                        characters
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="console-editor">
                              <AceEditor
                                style={{
                                  display: "flex",
                                  width: "96.5%",
                                  height: "45%",
                                  marginLeft: "1rem",
                                  marginRight: "1rem",
                                  borderRadius: "0.3125rem",
                                }}
                                id="codeTextArea"
                                mode="csharp"
                                theme="terminal"
                                onChange={(val) => {
                                  setEditorConsoleCode(val);
                                }}
                                name="UNIQUE_ID_OF_DIV"
                                editorProps={{ $blockScrolling: true }}
                                showPrintMargin={true}
                                showGutter={true}
                                highlightActiveLine={true}
                                value={editorConsoleCode}
                                setOptions={{
                                  enableBasicAutocompletion: true,
                                  enableLiveAutocompletion: true,
                                  enableSnippets: true,
                                  showLineNumbers: true,
                                  tabSize: 2,
                                }}
                              />
                              <div
                                style={{
                                  margin: "1rem",
                                  width: "100%",
                                }}
                              >
                                <div className="error-message-card-console-layout">
                                  <div className="error-message-card">
                                    <div className="select-language-field">
                                      <div className="error-message-flair">
                                        Error Message
                                      </div>
                                      <Field
                                        name="ruleErrorLanguage"
                                        placeholder="Select language"
                                        options={[{ Language: "English" }]}
                                        value={values.ruleErrorLanguage}
                                        component={FieldDropSide}
                                      />
                                    </div>
                                    <div className="error-message-field">
                                      <Field
                                        isRequired
                                        name="ruleErrorMessage"
                                        placeholder="Enter error message"
                                        type="text"
                                        value={values.ruleErrorMessage}
                                        component={FieldInput}
                                        noLabelTransform
                                      />
                                    </div>
                                    <div className="error-plus">
                                      <FontAwesomeIcon icon={faPlusCircle} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="shrink-new-rule-card">
                        <div className="shrink-drop-down">
                          <FontAwesomeIcon
                            onClick={() => {
                              setShrink(index);
                              setIsSubRuleSaved(false);
                            }}
                            icon={faChevronDown}
                          />
                        </div>
                        <div
                          style={{
                            alignSelf: "center",
                            width: "20%",
                            paddingRight: "15px",
                            color: "#646464",
                          }}
                        >
                          <AddToolTip name={values.ruleSet[index].ruleName} />
                        </div>
                        <div
                          className="expression-function"
                          style={{ width: "60%" }}
                        >
                          <div className="expression-flair mt-2">
                            Expression
                          </div>
                          <div className="function-flair mt-1 mb-2">
                            {toggle ? (
                              <AddToolTip
                                name={setRemoveOperator(
                                  values.ruleSet[index].ruleExpression
                                )}
                              />
                            ) : (
                              editorConsoleCode
                            )}
                          </div>
                        </div>
                        <div
                          className="d-flex"
                          style={{ width: "13%", alignItems: "center" }}
                        >
                          <div className="" style={{ width: "50%" }}>
                            <FontAwesomeIcon
                              onClick={() => {
                                setIsSubRuleSaved(false);
                                setShrink(index);
                              }}
                              className="rule-edit-icon"
                              icon={faEdit}
                            />
                          </div>
                          <div className="" style={{ width: "50%" }}>
                            <FontAwesomeIcon
                              onClick={() => remove(index)}
                              className="rule-delete-icon"
                              icon={faTrashAlt}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
              <div
                onClick={() => {
                  setIsSubRuleSaved(false);
                  setShrink(values["ruleSet"].length);
                  push({
                    ruleName: "",
                    ruleErrorLanguage: "English",
                    ruleErrorMessage: null,
                    ruleExpression: "",
                    filterCondition: "And",
                    isErrorValidation: true,
                    profileId: profileId,
                    ruleOperations: [
                      {
                        firstFieldRule: null,
                        conditionCategory: "IsNotNullOrEmpty",
                      },
                    ],
                  });
                }}
                // onClick={() => {
                //   setCount((prevCount) => [...prevCount, prevCount.length]);
                // }}
                className="add-new-rule-card"
              >
                + Add New Rule
              </div>
            </>
          )}
        </FieldArray>
      </div>
    </>
  );
};

export default AddNewRuleCard;
